import { useContext } from "react";
import shortsContext from "./context";

const useShortsContext = () => useContext(shortsContext);

export default useShortsContext;